export default {

    /**
     * Get tasks list
     * @param state
     * @returns {default.campaigns|{}}
     */
    getList: state => (node_id) => {

        // Return tasks list
        return Object.values(state.nodekpis).filter((ut) => ( ut.node_id === node_id && !ut.deleted_at));
    },

    /**
     * Get tasks list
     * @param state
     * @returns {default.campaigns|{}}
     */
    getValues: state => (node_kpi_id) => {

        // Return tasks list
        return Object.values(state.nodekpivalues).filter((ut) => ( ut.node_kpi_id === node_kpi_id && !ut.deleted_at));
    },

    /**
     * Get tasktag by id
     * @param state
     * @returns {default.campaigns|{}}
     */
    getByID: state => (id) => {
        // Return tasktag list
        return state.nodekpis[id];
    }

}
